<template>
  <div v-if="formData.EmbID" class="pa-3 bg-white border-bottom">
    <div class="caption font-weight-bold grey--text text--darken-3 mb-2 d-flex align-center">
      <v-icon x-small color="primary" class="mr-1">mdi-lock-outline</v-icon>
      LÍNEA BASE DEL PRESUPUESTO MAESTRO BLOQUEADO
    </div>

    <v-row dense>
      <!-- Card 1: Presupuesto total TM -->
      <v-col cols="12" sm="4" md="2">
        <div class="kpi-card pa-2 rounded-lg border-light bg-white d-flex flex-column justify-space-between">
          <div class="d-flex align-center justify-space-between">
            <span class="kpi-label">PRESUPUESTO TOTAL TM</span>
            <v-icon small color="blue darken-2">mdi-weight</v-icon>
          </div>
          <div class="d-flex align-baseline mt-1">
            <span class="kpi-value text-subtitle-1 font-weight-black grey--text text--darken-4">
              {{ formatNumber(budgetBaseline.TotalTons, 2) }}
            </span>
            <span class="kpi-unit ml-1 caption font-weight-bold grey--text text--darken-2">TM</span>
          </div>
        </div>
      </v-col>

      <!-- Card 2: Presupuesto total FCL -->
      <v-col cols="12" sm="4" md="2">
        <div class="kpi-card pa-2 rounded-lg border-light bg-white d-flex flex-column justify-space-between">
          <div class="d-flex align-center justify-space-between">
            <span class="kpi-label">PRESUPUESTO TOTAL FCL</span>
            <v-icon small color="cyan darken-2">mdi-cube-outline</v-icon>
          </div>
          <div class="d-flex align-baseline mt-1">
            <span class="kpi-value text-subtitle-1 font-weight-black grey--text text--darken-4">
              {{ formatNumber(budgetBaseline.TotalFcl, 1) }}
            </span>
            <span class="kpi-unit ml-1 caption font-weight-bold grey--text text--darken-2">FCL</span>
          </div>
        </div>
      </v-col>

      <!-- Card 3: Presupuesto total FOB -->
      <v-col cols="12" sm="4" md="2">
        <div class="kpi-card pa-2 rounded-lg border-light bg-white d-flex flex-column justify-space-between">
          <div class="d-flex align-center justify-space-between">
            <span class="kpi-label">PRESUPUESTO TOTAL FOB</span>
            <v-icon small color="green darken-2">mdi-currency-usd</v-icon>
          </div>
          <div class="d-flex align-baseline mt-1">
            <span class="kpi-value text-subtitle-1 font-weight-black green--text text--darken-3">
              ${{ formatNumber(budgetBaseline.TotalFobUsd, 2) }}
            </span>
            <span class="kpi-unit ml-1 caption font-weight-bold grey--text text--darken-2">USD</span>
          </div>
        </div>
      </v-col>

      <!-- Card 4: Clientes Presupuestados -->
      <v-col cols="12" sm="4" md="2">
        <div class="kpi-card pa-2 rounded-lg border-light bg-white d-flex flex-column justify-space-between">
          <div class="d-flex align-center justify-space-between">
            <span class="kpi-label">CLIENTES PRESUPUESTADOS</span>
            <v-icon small color="indigo darken-2">mdi-account-group-outline</v-icon>
          </div>
          <div class="d-flex align-baseline mt-1">
            <span class="kpi-value text-subtitle-1 font-weight-black grey--text text--darken-4">
              {{ budgetBaseline.BudgetClients || 0 }}
            </span>
            <span class="kpi-unit ml-1 caption font-weight-bold grey--text text--darken-2">clientes</span>
          </div>
        </div>
      </v-col>

      <!-- Card 5: Volumen sin Cliente -->
      <v-col cols="12" sm="4" md="2">
        <div class="kpi-card pa-2 rounded-lg border-light bg-white d-flex flex-column justify-space-between">
          <div class="d-flex align-center justify-space-between">
            <span class="kpi-label">VOLUMEN SIN CLIENTE</span>
            <v-icon small color="amber darken-3">mdi-account-question-outline</v-icon>
          </div>
          <div class="d-flex align-baseline mt-1">
            <span class="kpi-value text-subtitle-1 font-weight-black grey--text text--darken-4">
              {{ formatNumber(budgetBaseline.NoClientTons, 2) }}
            </span>
            <span class="kpi-unit ml-1 caption font-weight-bold grey--text text--darken-2">TM</span>
          </div>
        </div>
      </v-col>

      <!-- Card 6: División y Campaña -->
      <v-col cols="12" sm="4" md="2">
        <div class="kpi-card pa-2 rounded-lg border-light bg-white d-flex flex-column justify-space-between">
          <div class="d-flex align-center justify-space-between">
            <span class="kpi-label">DIVISIÓN Y CAMPAÑA</span>
            <v-icon small color="purple darken-2">mdi-calendar-range</v-icon>
          </div>
          <div class="d-flex align-baseline mt-1 text-truncate">
            <span class="kpi-value text-subtitle-2 font-weight-black grey--text text--darken-4 text-truncate">
              {{ formData.CmpName || '-' }}
            </span>
            <span class="kpi-unit ml-1 caption font-weight-bold grey--text text--darken-2">| {{ formData.TypeDestinationName || 'Frescos' }}</span>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { formatNumber } from "../utils/CommercialProgrammingCalculations";

export default {
  name: "CommercialBudgetSummary",
  props: {
    budgetBaseline: {
      type: Object,
      required: true,
    },
    formData: {
      type: Object,
      required: true,
    },
  },
  methods: {
    formatNumber,
  },
};
</script>

<style scoped>
.border-bottom {
  border-bottom: 1px solid #e2e8f0 !important;
}
.border-light {
  border: 1px solid #e2e8f0 !important;
}
.kpi-card {
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
  transition: all 0.2s ease;
}
.kpi-label {
  font-size: 10px;
  font-weight: 700;
  color: #64748b;
  letter-spacing: 0.5px;
  line-height: 1.2;
}
.kpi-value {
  color: #0f172a;
}
.kpi-unit {
  font-size: 11px;
}
</style>
